<div class="height-100">
  <uib-tabset active="$ctrl.currentTab" class="tabset">
    <uib-tab heading="Usos de máquinas" index="'usos'" disabled="$root.permissions.usosMaquinas.canRead" select="$ctrl.selectTab('usos')">
      <painel-historico-usos-maquinas ng-if="$ctrl.currentTab === 'usos'"></painel-historico-usos-maquinas>
    </uib-tab>
    <uib-tab heading="Máquinas em tempo real" index="'painel'" select="$ctrl.selectTab('painel')">
      <painel-maquinas ng-if="$ctrl.currentTab === 'painel'"></painel-maquinas>
    </uib-tab>
  </uib-tabset>
</div>
